export default "__VITE_ASSET__75bbf1c2__"